<script setup>
import { useI18n } from 'vue-i18n';
import CampaignMetricsChart from './CampaignMetricsChart.vue';

defineProps({
  meta: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();
</script>

<template>
  <div class="grid grid-cols-1 gap-6 mb-6 lg:grid-cols-4">
    <div class="grid grid-cols-1 gap-4 lg:col-span-3 md:grid-cols-4">
      <div
        class="p-4 rounded-xl bg-n-alpha-black2 border border-n-alpha-black2 shadow-sm"
      >
        <p class="text-xs font-medium text-n-slate-11 uppercase tracking-wider">
          {{ t('CAMPAIGN.DETAILS.METRICS.TOTAL') }}
        </p>
        <p class="mt-2 text-3xl font-bold text-n-slate-12">
          {{ meta.total || 0 }}
        </p>
      </div>
      <div class="p-4 rounded-xl bg-n-iris-1 border border-n-iris-3 shadow-sm">
        <p class="text-xs font-medium text-n-iris-11 uppercase tracking-wider">
          {{ t('CAMPAIGN.DETAILS.METRICS.DELIVERED') }}
        </p>
        <p class="mt-2 text-3xl font-bold text-n-iris-11">
          {{ meta.delivered || 0 }}
        </p>
      </div>
      <div class="p-4 rounded-xl bg-n-blue-1 border border-n-blue-3 shadow-sm">
        <p class="text-xs font-medium text-n-blue-11 uppercase tracking-wider">
          {{ t('CAMPAIGN.DETAILS.METRICS.READ') }}
        </p>
        <p class="mt-2 text-3xl font-bold text-n-blue-11">
          {{ meta.read || 0 }}
        </p>
      </div>
      <div class="p-4 rounded-xl bg-n-teal-1 border border-n-teal-3 shadow-sm">
        <p class="text-xs font-medium text-n-teal-11 uppercase tracking-wider">
          {{ t('CAMPAIGN.DETAILS.METRICS.REPLIED') }}
        </p>
        <p class="mt-2 text-3xl font-bold text-n-teal-11">
          {{ meta.replied || 0 }}
        </p>
      </div>
    </div>
    <div
      class="lg:col-span-1 h-40 rounded-xl border border-n-alpha-black2 bg-n-alpha-black2"
    >
      <CampaignMetricsChart :meta="meta" />
    </div>
  </div>
</template>
